import classes from "./InputField.module.css";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { IoChevronDownOutline } from "react-icons/io5";
import { useState, useRef, useEffect } from "react";

const InputField = ({
  labelText,
  className,
  labelStyle,
  type = "text",
  placeholder,
  showEye,
  onChange,
  value,
  name,
  disabled,
  error,
  dropdownOptions = null,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);

  const handleDropdownSelect = (option) => {
    setSelectedOption(option);
    onChange?.({ target: { name, value: option.value } });
    setShowDropdown(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={`${classes.wrapper} ${className}`} ref={dropdownRef}>
      <label style={labelStyle}>{labelText}</label>

      {dropdownOptions ? (
        <div className={classes.dropdownWrapper} onClick={() => setShowDropdown((prev) => !prev)}>
          <div className={`${classes.dropdownInput} ${(placeholder && !value) && classes.placeholderText} d-flex justify-between align-items-center`}>
            <span>{value || placeholder}</span>
            <IoChevronDownOutline
              className={`${classes.dropdownIcon} ${showDropdown ? classes.rotateUp : ""}`}
              size={18}
              color="#AFAFAF"
            />
          </div>
          {showDropdown && (
            <div className={classes.dropdownCard}>
              {dropdownOptions.map((option) => (
                <div
                  key={option.value}
                  className={classes.dropdownItem}
                  onClick={() => handleDropdownSelect(option)}
                >
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className={`${classes.inputContainer} d-flex align-items-center gap-2`}>
          <input
            type={showPassword ? "text" : type}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            name={name}
            disabled={disabled}
          />
          {showEye &&
            (showPassword ? (
              <IoEyeOutline
                size={18}
                color="#A7B4CA"
                role="button"
                onClick={() => setShowPassword(false)}
              />
            ) : (
              <IoEyeOffOutline
                size={18}
                color="#A7B4CA"
                role="button"
                onClick={() => setShowPassword(true)}
              />
            ))}
        </div>
      )}

      <div className={`${classes.error}`}>{error}</div>
    </div>
  );
};

export default InputField;